import apiService from './api.js';

export const authService = {
  // Fazer login
  async login(credentials) {
    try {
      const response = await apiService.post('/auth/login', credentials);
      
      if (response.success && response.data.token) {
        // Salvar token no localStorage
        localStorage.setItem('ecf_token', response.data.token);
        localStorage.setItem('ecf_user', JSON.stringify(response.data.user));
        
        // Configurar header de autorização para futuras requisições
        this.setAuthHeader(response.data.token);
        
        return response.data;
      }
      
      throw new Error(response.message || 'Erro no login');
    } catch (error) {
      // Error logged by API service
      throw error;
    }
  },

  // Fazer logout
  async logout() {
    try {
      await apiService.post('/auth/logout', {});
    } catch (error) {
      // Error logged by API service
    } finally {
      // Limpar dados locais independentemente do resultado da API
      localStorage.removeItem('ecf_token');
      localStorage.removeItem('ecf_user');
      this.removeAuthHeader();
    }
  },

  // Obter dados do usuário logado
  getCurrentUser() {
    try {
      const userStr = localStorage.getItem('ecf_user');
      return userStr ? JSON.parse(userStr) : null;
    } catch (error) {
      // Error parsing user data from localStorage
      return null;
    }
  },

  // Obter token atual
  getToken() {
    const token = localStorage.getItem('ecf_token');
    if (!token) return null;

    // Verificar se o token está expirado
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const now = Math.floor(Date.now() / 1000);

      if (payload.exp && payload.exp < now) {
        // Token expired, removing from localStorage
        localStorage.removeItem('ecf_token');
        localStorage.removeItem('ecf_user');
        return null;
      }

      return token;
    } catch (error) {
      // Invalid token format, removing from localStorage
      localStorage.removeItem('ecf_token');
      localStorage.removeItem('ecf_user');
      return null;
    }
  },

  // Verificar se está autenticado
  isAuthenticated() {
    return !!this.getToken();
  },

  // Configurar header de autorização
  setAuthHeader(token) {
    // O header será configurado automaticamente pelo apiService
    // usando o token do localStorage
  },

  // Remover header de autorização
  removeAuthHeader() {
    // Header será removido automaticamente quando não houver token
  },

  // Verificar status da autenticação no servidor
  async checkAuthStatus() {
    try {
      const response = await apiService.get('/auth/status');
      return response.authenticated;
    } catch (error) {
      // Error logged by API service
      return false;
    }
  },

  // Obter perfil do usuário
  async getProfile() {
    try {
      const response = await apiService.get('/auth/profile');
      return response.data;
    } catch (error) {
      // Error logged by API service
      throw error;
    }
  }
};